import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d75c9d9c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "audiences-stats-skeleton" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "cols d-flex align-items-center justify-content-between" };
const _hoisted_4 = { class: "d-flex" };
const _hoisted_5 = { class: "d-flex" };
import SkeletonLoader from '@/components/_atoms/SkeletonLoader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceFooterSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                            _createVNode(SkeletonLoader, {
                                height: "19px",
                                width: "240px",
                                class: "mb-12 d-block"
                            }),
                            _createVNode(SkeletonLoader, {
                                height: "19px",
                                width: "110px"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(SkeletonLoader, {
                                height: "33px",
                                width: "40px",
                                class: "mr-12"
                            }),
                            _createVNode(SkeletonLoader, {
                                height: "33px",
                                width: "40px",
                                class: "mr-12"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(SkeletonLoader, {
                                width: "180px",
                                class: "mr-12"
                            }),
                            _createVNode(SkeletonLoader, { width: "180px" })
                        ])
                    ])
                ])
            ]));
        };
    }
});
